import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import {
	Card,
	CardHeader,
	CardContent,
	CardFooter,
} from "@/components/ui/card";

/**
 * PostSkeleton - Loading skeleton for post items
 * Displays placeholder content while posts are loading
 */
const PostSkeleton = () => {
	return (
		<Card className="border-2 border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
			<CardHeader className="pb-2">
				<div className="flex items-start justify-between">
					<div className="flex flex-1 items-center gap-3">
						<Skeleton className="h-10 w-10 rounded-full bg-muted dark:bg-muted" />
						<div className="flex-1 space-y-2">
							<div className="flex items-center gap-2">
								<Skeleton className="h-5 w-24 bg-muted dark:bg-muted" />
								<Skeleton className="h-5 w-16 rounded-full bg-muted dark:bg-muted" />
							</div>
							<Skeleton className="h-4 w-20 bg-muted dark:bg-muted" />
						</div>
					</div>
				</div>
			</CardHeader>
			<CardContent className="space-y-3 pb-2">
				<Skeleton className="h-6 w-3/4 bg-muted dark:bg-muted" />
				<Skeleton className="h-4 w-full bg-muted dark:bg-muted" />
				<Skeleton className="h-4 w-5/6 bg-muted dark:bg-muted" />
				<Skeleton className="h-48 w-full rounded-md bg-muted dark:bg-muted" />
			</CardContent>
			<CardFooter className="flex items-center gap-4 pt-2">
				<Skeleton className="h-8 w-20 bg-muted dark:bg-muted" />
				<Skeleton className="h-8 w-20 bg-muted dark:bg-muted" />
				<Skeleton className="h-8 w-20 bg-muted dark:bg-muted" />
			</CardFooter>
		</Card>
	);
};

export default PostSkeleton;
